<section class="wrap-solutions">
  <div class="layout">
    <h1 class="subtitle">Soluções</h1>
    <div class="list-solutions">
      <a *ngFor="let solution of solutions" class="solution-card" [href]="solution.link">
        <figure class="photo">
          <img [src]="solution.imgSrc" [alt]="solution.imgAlt">
        </figure>
        <div class="infos">
          <h2>{{ solution.title }}</h2>
          <p>{{ solution.description }}</p>
        </div>
      </a>
    </div>
  </div>
</section>
